/**
 * @file  services/Semaphore.ts
 * @description  provides a simple semaphore to prevent multiple request a particular resources.
 *
 * @author ogarcia (ozkary)
 *
 */

/**
 * Simple Semaphore implementation to block two concurrent actions on the same resource.
 *
 * Todo:  Add counter to support more than two active promises
 */
export class Semaphore {
  status: boolean;
  public constructor(status = false) {
    this.status = status;
  }

  /**
   * when true the semaphore is active
   */
  get active(): boolean {
    return this.status;
  }

  /**
   * set to true to activate semaphore. false to deactivate
   */
  set active(status: boolean) {
    this.status = status;
  }
}
